var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgZenGeorge = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 97,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#040222",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M3.43 96.79h76.8c4.77 0 5.9-1.71 4.51-4.44-1.87-3.67-7.87-15.17-8.3-16.14-.45-.98-1.42-1.87-4.25-1.87H18.8c-3.26 0-4.41 1.15-6 3.37-1.6 2.22-9.82 12.7-10.97 14.55-1.16 1.86-2.39 4.53 1.6 4.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D21D2",
    stroke: "#040222",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M3.43 96.79h76.8c4.77 0 5.9-1.71 4.51-4.44-1.87-3.67-7.87-15.17-8.3-16.14-.45-.98-1.42-1.87-4.25-1.87H18.8c-3.26 0-4.41 1.15-6 3.37-1.6 2.22-9.82 12.7-10.97 14.55-1.16 1.86-2.39 4.53 1.6 4.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M3.43 96.79h76.8c4.77 0 5.9-1.71 4.51-4.44-1.87-3.67-7.87-15.17-8.3-16.14-.45-.98-1.42-1.87-4.25-1.87H18.8c-3.26 0-4.41 1.15-6 3.37-1.6 2.22-9.82 12.7-10.97 14.55-1.16 1.86-2.39 4.53 1.6 4.53Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M56.36 77.58s3 .1 6.74.13l7.96.06"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M16.2 82.43h6.06c.46 0 1.84.46 1.23 1.79a36.5 36.5 0 0 1-1.64 3.11c-.36.6-.76 1.23-2.44 1.23h-6.97c-1.12 0-.96-.92-.46-1.74.5-.82 1.48-2.81 2.04-3.47.55-.67 1.22-.92 2.18-.92Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M16.72 84.29s-1.43 1.83.71 1.92c2.15.1 2.48-1.92 2.48-1.92M17.43 86.21l-1.28 2.36M13.96 84.57s.6.13 1.67.08M20.56 84.65s1.34.06 2.7.04M19.71 85.99s2.12.12 2.88.03M12.53 85.85s1.84.2 3.1.14"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 36,
    height: 4,
    x: 28,
    y: 81,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M63.91 82.82c-.06-.69-1.31-.95-4.7-.95-3.37 0-13.4.07-13.4.07-3.2.01-11.17.05-13.63.08-2.45.03-3.83.43-3.87.86-.03.45 2.3.8 4.06.83 1.25.03 4.5.16 8.26.23.98.18 1.08.93 4.61.94 3.9.02 4.25-.95 5.65-1.01H51.04l7.42-.2c2.47-.05 5.51-.16 5.45-.85Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "m25.41 81.63 2.64 3.86-2.41-4.55 3.76 5.48-2.83-5.48s3.47 2.57 2.74 4.87c-.74 2.3-.88-4.87-.88-4.87s3.89 5.42 3 5.48c-.87.06-2.59-2.87-2.3-6.08.27-3.2 3.48 5.49 3.48 5.49l-6.18-1 5.66-5.2 1.02 6.67-5-7.62 4.68 8.29-2.92-9.06 3.54 8-2.52-7.23 3.84 7.8-3.05-8.27 3.26 7.27-1.53-4.68 2.07 4.03-1.05-3.67 1.63 3.67-1.12-3.84L36.56 85l-1.13-4.22 1.8 4.22-.23-4.04-1.36 4.09 2.2-.1s-3.05-5.31-1.48-5.46c1.58-.16 1.47 6.4 1.47 6.4s-.07-5.12 1.96-5.2c2.03-.08-1.35 4.6-1.35 4.6v-5.08l.76 5.64.11-6.44.65 6.36.06-6 .53 6.31.28-5.26.58 5.85h.84l-2.01-6.94 2.75 7.48-1.79-7.02s2.33 5.51 2.1 6.5c-.22.98-.7-6.73-.7-6.73l-.63.57 2.29 7.1-.87-6.7-1.68-1.65 3.38 7.9.66-.53-2.76-5.87 2.64 6.97.43-1.81-2.28-5.54 1.44 8.04-.71-9.02 1.55 9.02-.79-7.9 1.24 5.73s-.23-4.67-.83-5.74c-.61-1.08 1.88 5.54 1.52 5.9-.35.37-.58-5.67-.58-5.67l1.22 5.66-.61-5.4 1.1 4.97-.47-5.06 1.3 5 .47-.43-1.95-4.85 2.44 4.7-1.35-4.16 1.8 4.11-1.29-4.21 1.82 4.29s-.45-5.31-1.13-5.33c-.69-.03.5 3.36 1.55 4.61 1.04 1.25-.95-4.39-.95-4.39s.62 4.75 2.2 4.7c1.57-.05-.95-4.37-.95-4.37s-.53 3.5 1.58 4.24c2.1.74-4.78-5.9-4.78-5.9l5.94 5.7-1.54-3.5 2.72 3.73-2.03-3.94s1.57 2.82 3.13 3.5c1.55.69-2.02-3.5-2.02-3.5s.33 2.92 2.95 3.63-1.8-4-1.8-4 .25 2.8 3.35 3.98c3.1 1.17-1.5-3.86-1.5-3.86s1.25 4.27 3.3 3.98c2.07-.28-4.14-3.98-4.14-3.98l2.73 4.54 2.8-.76-3.4-3.83s1.67 4.19 2.86 4.29c1.2.1 1.48-.64 1.48-.64l-2.54-3.5s-.4 4.77 1.15 4.72c1.55-.04 2.72-1.14 2.72-1.14l-1.6-3.45-2.7 4.98 5.24-2.02-1.52-2.86-.29 3.09-1.9-3.2.79 3.35-2.65-3.5-1.22 4.21 5.75-3.8 1.37 2.01-10.67-2.2 10.68 3.2"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAE900",
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "m45.8 11.06.55 3.22 2.16 7.4s3.31 4.83-5.5 4.83c-6.81 0-2.17-4.99-2.17-4.99l-.6-3.6-.09-.25a2.4 2.4 0 0 1-1.07-1.6c-.1-.64-.71-3.81-.71-3.81l-.09-.5-.54-2.23-.58-2.27-.24.14s-.04.76-1.42.94c-1.05.13-2.14-2.32-2.14-2.32s-.36 1.59-2.08.56C29.16 5.3 30.3.36 31.3.23c1-.14 2.64 1.32 2.64 1.32s.87-.34 2.27-.22c1.39.12 3.94 1.7 3.94 1.7.09-.37.45-.73 1.78-.75 1.34-.03 2.83 2.77 3 3.75l.43 2.49.44 2.54Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAE900",
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "m44.92 6.02.44 2.5.44 2.54-4.6 2.16-2.83-.97-.08-.49s-1.13 0-1.35-.92c-.23-.92.8-1.31.8-1.31l-.57-2.27c-.15.08 2-2.5 2-2.5l5.75 1.26Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#040222",
    stroke: "#040222",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M40.46 19.18s1.28 1.37 3.18.72c1.91-.65 1.63-2.85 1.42-4.74-.21-1.9-5 2.22-5 2.22l.18.53.22 1.27Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED7976",
    stroke: "#040222",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "m46.35 14.27-1.43-8.25c-.17-.98-1.65-3.77-2.99-3.75-1.33.02-1.7.39-1.78.76 0 0-2.55-1.59-3.94-1.7-1.4-.13-2.27.21-2.27.21S32.31.08 31.3.22c-1.01.13-2.14 5.08-.01 6.35C33 7.59 33.37 6 33.37 6s1.1 2.45 2.14 2.32c1.39-.18 1.42-.94 1.42-.94s.7-.4 1.16-.52c.46-.12.5-.56.73-.58.23-.02 1.04 1 2.12.71 1.07-.28 1.35-.63 1.73-.38.38.25 1.12 3.34 1.16 3.88.05.55-.23 1.03-.94 1.27-2.74.97-4.52.48-4.52.48s.62 3.16.72 3.82c.1.65.83 2.3 3.2 1.9 2.36-.42 3-1.84 2.7-3.76-.3-1.92-.2-1.85-.2-1.85s.53 1.63 1.56 1.9Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAE900",
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M44.45 8.62s1.82-.58 2.12.97c.37 1.9-1.59 1.46-1.59 1.46l-.32-1.42-.2-1.01Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M30.97 3.6s.8-.35 1.36-.03c.56.33 1.01 1.08 1.21 1.08.2.01.03-.52.23-.53.2-.02 1.77 1.35 2.62 1.2.85-.16-.08-1.17.63-1.36.71-.18 3.58 1.3 4.8 1.13M44.41 8.42s.45 2.3.62 2.81"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M43.13 8.42c0 .78-.54 1.04-1.36 1.04-.81 0-1.47-.62-1.47-1.4 0-.78.34-1.38 1.16-1.38.81 0 1.67.96 1.67 1.74ZM39.18 8.42c0 .77-.7 1.76-1.35 1.76-.66 0-1.04-.62-1.04-1.4 0-.76.37-1.38 1.04-1.38.66 0 1.35.25 1.35 1.02Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M40.32 8.32s-.29-.31-.59-.25c-.3.05-.48.2-.56.52M39.87 8.6s-.41 1.84-.42 2.1c0 .28.78.42 1.13.18M40.06 14.17s.31 1.26 1.22 1.13c.84-.12.54-1.75.54-1.75M41.22 8.33s-.17-.53.26-.53c.42 0 .6.53.6.53M41.57 8.27 41.53 8M37.9 8.9s-.22-.52.2-.57c.41-.04.6.4.6.4M38.22 8.79l-.04-.28M38.2 10.98l.15 1.12"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M45.16 51.44c-6.57.07-22.86.4-27.88.67s-7.84 3.57-7.9 7.34c-.07 3.77 4.69 6.73 8.3 7.06 3.62.34 15.61 2.5 27.02 2.1 7.36-.27 21.3-1.89 26.33-2.43 5.02-.53 11.26-1.48 11.12-7.33-.13-5.85-2.68-8-9.58-8s-27.4.6-27.4.6Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M45.47 52.57v4.37M46.82 54.33c.36 0 .44-.43.44-.56 0-.14-.2-.56-.44-.56s-.41.35-.41.65c0 .32.22.47.4.47Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M21.1 58.98s9.1.74 14.33.6c5.23-.13 15.88-.33 18.9-.6 3.02-.27 14.2-1.41 16.09-1.62"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D21D2",
    stroke: "#040222",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M32.6 59.59s.42 6.46 0 8.62l2.3.21s4.1-3.52 4.13-4.9c.02-1.4-3.59-3.93-3.59-3.93H32.6Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "m34.93 61-1.03 1M34.72 63.35l1 1.04M33.4 66.89l1.04-1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D21D2",
    stroke: "#040222",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M56.93 58.73s-.15 5.3.99 8.84l-2.58.25s-4.08-2.4-4.08-3.87c0-1.46 3.54-5.02 3.54-5.02l2.13-.2Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "m54.87 60.68.93.93M54.58 62.76l-.7 1.24M55.8 64.39l.68 1.1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAE900",
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M70.79 31.98s2.3-1.82 2.7-3.15c0 0-.2.6-.63 1.1 0 0 .1-2.15-.12-3.4-.2-1.26-.04-3.16.62-3.9.66-.76.77-.9 1.09-1.08.31-.18.6-.13.77.16.16.3 0 .7-.2.91-.2.2-1.26 1.42-.85 2.1.41.69 1.23-.09 1.48-.39.25-.3 1.59-2 1.84-2.26.26-.25.39-.63.16-.9-.22-.28-1.38.47-1.59.68-.2.2-.7.22-.84-.14-.13-.36.08-.66.4-.89.3-.22.92-.68 1.58-.93s1.16.1 1.34.34c.18.25.55.89.5 1.6-.04.7-.25 1.66-1.39 3 0 0 .85-.8 1.69-2.78.84-1.98 1.27-3.72 1.75-4.22.48-.5.84.07.81.4-.02.35-.2 2.12-.72 3.2-.52 1.07-1.34 3.12-2.09 4.04 0 0 .68-.72 2-3.83 1.3-3.12 1.81-2.69 1.95-2.63.14.07.47.68.1 1.61-.37.94-1.28 3.64-3.34 6.66 0 0 2.06-3.17 2.53-3.93.46-.76.83-.65.99-.56.16.1.44.73.14 1.31-.3.58-.82 2.54-2.93 4.97-2.12 2.44-3.27 4.03-4.14 4.86-.87.84-1.93 2.1-1.93 2.1l-2.48.36-1.2-4.41Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M74.94 30.15s1.22-.84 2.04-2.58"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAE900",
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M18.37 34.2s-1.48-1.68-1.55-2.21c-.06-.54-.09-2.55.2-4.82.27-2.26-.9-3.2-1.05-3.39-.17-.18-.54-.4-.77-.09-.23.3-.35.59 0 1.26.35.68.51 1.98.12 2.25-.4.28-1.47-1.73-1.75-2.27-.29-.55-.6-1.25-.77-1.55-.16-.3-.1-.6.09-.73.2-.12 1.17.64 1.5.91.32.29.65.26.8.13.15-.13.23-.62-.24-1.08-.48-.46-1.9-1.43-2.57-.99-.68.45-.97 1.3-.92 1.84.04.55.14 1.36 1.2 3.02 0 0-1.75-2.39-2.01-4.34-.27-1.96-.84-2.91-1.03-3.15-.2-.24-.78-.29-.7.47.07.75-.02 1.33.42 2.92.44 1.59 1.73 4.59 1.73 4.59s-1.33-3.15-1.73-4.6c-.4-1.44-1.21-2.32-1.59-2.17-.37.16-.4 1.24-.17 1.96.24.72 1.99 5.66 2.53 6.48 0 0-1.88-4.26-2.25-4.62-.37-.36-.8-.24-.91-.12-.12.12-.27.4.09 1.17.36.79.66 2.22 1.56 3.92.9 1.71 1.7 3.57 2.84 4.31 1.14.74 1.72 1.02 1.72 1.02s-1.43-.8-1.72-1.02l3.32 4.64 2.65.75 1.54-1.88-.58-2.61Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.27 38.9s-5.3 4.67-7.29 6.31c-1.98 1.64-3.27 1.37-4.55.47-1.29-.9-7.67-7.74-7.67-7.74s.57-.26 1.63-1.17c1.05-.91 1.98-2.57 1.98-2.57l5.17 5.17-1.3-1.3c1.22-.56 7.68-10.52 10.65-12.81 2.97-2.29 7.96-3.74 7.96-3.74s-.45 3.08 3.2 3.08c3.64 0 4.48-2.57 4.36-3.28l2.85.36c1.23.16 4 1.5 5.56 3.26a715.93 715.93 0 0 1 9.11 11.08l-.93.89s4.53-4.23 5.79-4.93c0 0 .8 1.67 1.64 2.47a17 17 0 0 0 2.02 1.6S69.5 43.1 68 44.2c-1.51 1.09-3.7 1.67-5.43.03-1.73-1.65-7.63-9.34-7.63-9.34l-.03-5.06.03 5.06.14 16.28s-1.84 1.19-9.46 1.19c-6.84 0-9.16-.71-9.16-.71s-1.81-8.37-2.18-12.75c-.37-4.39-.54-7.3-.54-7.3s.2 4.28.54 7.3Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M34.27 38.9s-5.3 4.67-7.29 6.31c-1.98 1.64-3.27 1.37-4.55.47-1.29-.9-7.67-7.74-7.67-7.74s.57-.26 1.63-1.17c1.05-.91 1.98-2.57 1.98-2.57l5.17 5.17-1.3-1.3c1.22-.56 7.68-10.52 10.65-12.81 2.97-2.29 7.96-3.74 7.96-3.74s-.45 3.08 3.2 3.08c3.64 0 4.48-2.57 4.36-3.28l2.85.36c1.23.16 4 1.5 5.56 3.26a715.93 715.93 0 0 1 9.11 11.08l-.93.89s4.53-4.23 5.79-4.93c0 0 .8 1.67 1.64 2.47a17 17 0 0 0 2.02 1.6S69.5 43.1 68 44.2c-1.51 1.09-3.7 1.67-5.43.03-1.73-1.65-7.63-9.34-7.63-9.34l-.03-5.06.03 5.06.14 16.28s-1.84 1.19-9.46 1.19c-6.84 0-9.16-.71-9.16-.71s-1.81-8.37-2.18-12.75Zm0 0c-.37-4.39-.54-7.3-.54-7.3s.2 4.28.54 7.3Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "M45.85 26.66s-.26.88.3.79c.54-.1.5-.55.34-.74-.17-.2-1.03-.05-1.03-.05M46.94 37.12s-.77.3-.21.8c.55.5.91-.7.2-.8ZM47.89 47.37c-.52-.19-.86.75-.36.93.5.18.9-.73.36-.93ZM44.24 24.7l1.63 25.58"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#AE90E8",
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M35.44 59.59s2.52 3.06 2.44 3.86c-.09.92-3.47 3.38-3.47 4.94 0 .78 4.75 1.43 4.69 4.66-.05 2.54.2 6.51 3.15 6.46 2.94-.05 3.1-1.52 3.1-1.52V59.31s-.3.04-1.4.07l-8.5.2Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M43.76 73.05c-.16-3.3.07-9.7-.02-11.44-.05-.9.22-2.23-.52-2.2l-7.79.18s2.52 3.06 2.45 3.86c-.1.93-3.47 3.38-3.47 4.94 0 .78 4.75 1.43 4.68 4.66-.05 2.54.2 6.51 3.15 6.46.57 0 1.05-.07 1.43-.17 0-1.4.2-4.01.09-6.3Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAE900",
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M43.68 64.2c-.58-.14-1.88-.39-2.17-.36-.56.07-1.38.14-1.28 1.48.1 1.29 2.19 6.3 3.5 7.15 0-2.64 0-5.59-.05-8.28Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M36.05 69.28s.67-.9 1.12-1.34c.45-.44 1.06.07.75.6l-.87 1.4.87-1.4c.3-.47.97 0 .7.51l-.79 1.4.63-1.11c.2-.38 1-.04.67.6-.36.7-.7 1.2-.7 1.2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M40.55 78.92s.17-3.83.17-5.08c0-.83-2.28-2.72-2.28-2.72"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "m39.79 75.02.19.18M39.74 73.93l.21-.15M39.9 76.1l.12.4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#AE90E8",
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M54.8 58.94s-3.02 4.57-3.02 5.24c0 .66 4.56 2.44 4.69 3.54.14 1.1-2.12.07-3.3 2.36-1.18 2.3-1.15 4.5-1.15 5.57 0 1.09-.52 3.76-3.13 3.75-2.6-.02-3.54-1.41-3.54-1.41V59.3h.93c.46 0 8.52-.37 8.52-.37Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M56.47 67.72c-.14-1.1-4.7-2.89-4.7-3.54 0-.67 3.03-5.24 3.03-5.24l-7.62.34c-.36.03-.3 1.71-.3 2.13.04.94.2 5.37.2 8.04 0 1.94.06 7.92.49 9.81a6 6 0 0 0 1.32.15c2.6 0 3.13-2.67 3.13-3.75s-.04-3.28 1.14-5.57c1.19-2.3 3.44-1.27 3.31-2.37Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    d: "m51.4 73.45-.2.23M51.12 74.66l.23.3M51.37 76.04l-.21.25"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M50.8 78.73s-.4-4.38-.46-5.17c-.05-.78 2.46-2.7 2.46-2.7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAE900",
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M48.39 63.65c-.31 0-1.12.34-1.35.51 0 2.14.09 4 .03 5.2-.03.68.08 1.9.08 3.2.8-1.2 2.2-5 2.43-6.23.26-1.37-.24-2.68-1.2-2.68Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    d: "M54.58 68.63s-.76-1.03-1.26-1.42c-.5-.4-1.05.19-.68.68.35.45 1.1 1.33 1.1 1.33l-1.1-1.33c-.35-.44-.95.12-.62.59.52.74 1.17 1.53 1.17 1.53s-.74-.91-.99-1.26c-.25-.36-1 .07-.6.67.44.65 1.2 1.45 1.2 1.45"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h85v97H.5z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZenGeorge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Zen-George.2071d42002097299f212242d1eec627b.svg";